module.exports = __webpack_public_path__ + "img/gaming.eb79268.png";